export const scopesToI18n = scopes => scopes.map(s => `oauth.scopes.${s}`)
